import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '岗位角色',
    type: 'OO_OR',
}
